module.exports = __webpack_public_path__ + "static/media/bg.dbd03fb6.jpg";